// components/ViewDetailsComponent.tsx
import { Row, Col, Typography, Divider } from "antd";
import React from "react";

const ViewDetailsComponent = ({ row }: { row: any }) => {
  return (
    <div
      style={{
        padding: "16px",
        background: "#f9f9f9",
        borderRadius: "8px",
      }}
    >
      <Row gutter={[30, 8]}>
        <Col span={10}>
          <Typography.Text strong>Өдөр:</Typography.Text>
          <Typography.Paragraph>{row?.day}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Цаг:</Typography.Text>
          <Typography.Paragraph>{row?.bookedTime}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Багц:</Typography.Text>
          <Typography.Paragraph>{row?.packageName}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Төлбөрийн хэлбэр:</Typography.Text>
          <Typography.Paragraph>{row?.paymenType}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Урьдчилгаа:</Typography.Text>
          <Typography.Paragraph style={{ color: "green" }}>{row?.prePay}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Үлдэгдэл:</Typography.Text>
          <Typography.Paragraph style={{ color: "green" }}>{row?.postPay}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Нийт:</Typography.Text>
          <Typography.Paragraph style={{ color: "red" }}>{row?.postPay + row?.prePay}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Тайлбар:</Typography.Text>
          <Typography.Paragraph>{row?.description}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Нэмэлт төлбөр:</Typography.Text>
          <Typography.Paragraph>{row?.addPayment}</Typography.Paragraph>
        </Col>
        <Col span={10}>
          <Typography.Text strong>Хямдрал:</Typography.Text>
          <Typography.Paragraph>{row?.minusPayment}</Typography.Paragraph>
        </Col>

        <Col span={10}>
          <Divider>Дагалдах зураг</Divider>
          {(row?.pictures ?? []).length > 0 ? (
            row.pictures.map((picture: any) => (
              <div key={picture._id} style={{ marginBottom: "8px" }}>
                <Typography.Text>
                  <strong>Size:</strong> {picture.size}, <strong>Count:</strong> {picture.count}
                </Typography.Text>
              </div>
            ))
          ) : (
            <Typography.Text>Мэдээлэл байхгүй</Typography.Text>
          )}
        </Col>

        <Col span={10}>
          <Divider>Нэмэлт зураг</Divider>
          {(row?.paper ?? []).length > 0 ? (
            row.paper.map((picture: any) => (
              <div key={picture._id} style={{ marginBottom: "8px" }}>
                <Typography.Text>
                  <strong>Size:</strong> {picture.size}, <strong>Count:</strong> {picture.count}
                </Typography.Text>
              </div>
            ))
          ) : (
            <Typography.Text>Мэдээлэл байхгүй</Typography.Text>
          )}
        </Col>

        <Col span={10}>
          <Divider>Дан Жааз</Divider>
          {(row?.frame ?? []).length > 0 ? (
            row.frame.map((picture: any) => (
              <div key={picture._id} style={{ marginBottom: "8px" }}>
                <Typography.Text>
                  <strong>Size:</strong> {picture.size}, <strong>Count:</strong> {picture.count}
                </Typography.Text>
              </div>
            ))
          ) : (
            <Typography.Text>Мэдээлэл байхгүй</Typography.Text>
          )}
        </Col>

        <Col span={10}>
          <Divider>Жаазтай зураг</Divider>
          {(row?.frameAndPaper ?? []).length > 0 ? (
            row.frameAndPaper.map((picture: any) => (
              <div key={picture._id} style={{ marginBottom: "8px" }}>
                <Typography.Text>
                  <strong>Size:</strong> {picture.size}, <strong>Count:</strong> {picture.count}
                </Typography.Text>
              </div>
            ))
          ) : (
            <Typography.Text>Мэдээлэл байхгүй</Typography.Text>
          )}
        </Col>

        <Col span={10}>
          <Divider>Канвас зураг</Divider>
          {(row?.canvas ?? []).length > 0 ? (
            row.canvas.map((picture: any) => (
              <div key={picture._id} style={{ marginBottom: "8px" }}>
                <Typography.Text>
                  <strong>Size:</strong> {picture.size}, <strong>Code:</strong> {picture.code}, <strong>Price:</strong> {picture.price}
                </Typography.Text>
              </div>
            ))
          ) : (
            <Typography.Text>Мэдээлэл байхгүй</Typography.Text>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ViewDetailsComponent;